require('./bootstrap');
var numeral = require('numeral');

import * as RecordForm from './ko/RecordForm';
import * as RegisterForm from './ko/RegisterForm';
import * as ImportWidget from './ko/ImportWidget';
import * as PageFilterWidget from './ko/PageFilterWidget';

window.RecordForm = RecordForm;
window.RegisterForm = RegisterForm;
window.ImportWidget = ImportWidget;
window.PageFilterWidget = PageFilterWidget;
window.bootstrap = require('bootstrap');

function _confirm(message,success_callback,cancel_callback){
    $.confirm({
        title: '',
        content: message,
        type: 'blue',
        useBootstrap: true,
        theme:'bootstrap',
        buttons: {
            ok: {
                text: "Accept",
                btnClass: 'btn-primary',
                keys: ['enter'],
                action: success_callback
            },
            cancel: {
                text: 'Cancel',
                action: cancel_callback
            }
        }
    });
}

function _alert(message){
    $.alert({
        content: message
    });
}

window._confirm = _confirm;
window._alert = _alert;
